import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { Home, User, FolderKanban, Briefcase, PenLine, BookOpen, Mic, Mail, Calendar, Linkedin } from "lucide-react";
import { LINKS, useContent } from "../lib/content";

const PAGES = [
  { icon: Home, label: "Home", to: "/" },
  { icon: User, label: "About", to: "/about" },
  { icon: FolderKanban, label: "Projects", to: "/projects" },
  { icon: Briefcase, label: "Services", to: "/services" },
  { icon: PenLine, label: "Blog", to: "/blog" },
  { icon: BookOpen, label: "Resources", to: "/resources" },
  { icon: Mic, label: "Speaking", to: "/speaking" },
  { icon: Mail, label: "Contact", to: "/contact" },
];

export const CommandPalette = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const { posts } = useContent();
  const go = (fn) => { setOpen(false); fn(); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Search pages, articles and actions..." data-testid="command-palette-input" />
      <CommandList data-testid="command-palette-list">
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Navigate">
          {PAGES.map(({ icon: Icon, label, to }) => (
            <CommandItem key={to} onSelect={() => go(() => navigate(to))} data-testid={`palette-item-${label.toLowerCase()}`}>
              <Icon size={15} className="mr-2 text-muted-foreground" /> {label}
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandGroup heading="Articles">
          {posts.map((p) => (
            <CommandItem
              key={p.slug}
              value={`${p.title} ${p.category} ${p.excerpt}`}
              onSelect={() => go(() => navigate(`/blog/${p.slug}`))}
              data-testid={`palette-article-${p.slug}`}
            >
              <PenLine size={15} className="mr-2 text-muted-foreground shrink-0" />
              <span className="truncate">{p.title}</span>
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => go(() => window.open(LINKS.calendly, "_blank"))} data-testid="palette-item-book">
            <Calendar size={15} className="mr-2 text-muted-foreground" /> Book a Consultation
          </CommandItem>
          <CommandItem onSelect={() => go(() => window.open(LINKS.linkedin, "_blank"))} data-testid="palette-item-linkedin">
            <Linkedin size={15} className="mr-2 text-muted-foreground" /> Open LinkedIn
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};
